import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";
import { Loader } from "src/components/loader";
import moment from "moment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import IconDownload from "src/assets/images/icon_download.svg";
import { Button } from "@mui/material";


export const Monthly = ({ data }) => {

  /** redux store useDispatch & useSelector ------------------------------ **/
  const { filterAllData } = useSelector((state) => state.goodsin);
  const { isDropdownOpenFlagValue } = useSelector((state) => state.dashboard);
  const { signoutModelOpenFlag } = useSelector((state) => state.auth);

  /** hooks useState ----------------------------------------------------- **/
  const [monthlyData, setMonthlyData] = useState([]);
  const [loadingState, setLoadingState] = useState(true)

  /** Variable declarations----------------------------------------------------- **/
  const filterData = filterAllData["Inventrory"];
  let userDetails = JSON.parse(localStorage.getItem("userDetails"))

  /** hooks useEffect----------------------------------------------------- **/

  useEffect(() => {
    setLoadingState(false)
    setMonthlyData([...data]);
  }, [data]);

  const generateHeaders = (tableData, weeksData) => {
    const headers = [
      "REF NO",
      "DEPOT",
      "MANAGER",
      "CLIENT",
      "PROJECT",
      "ITEMS",
      "DESCRIPTION",
      "CONDITION",
      "QTY RECEIVED",
      "QTY DISPATCHED",
      "QTY REMAINING"
    ];
    return headers;
  };

  const saveExcelFile = (
    tableData,
    dateFromStr,
    dateToStr,
    depotStr,
    clientStr,
    projectStr,
    weeksData
  ) => {

    const headers = generateHeaders(tableData, weeksData);
    let AdminHeaderChanges = [
      ["Date:", `${moment(dateFromStr).format("DD-MMM-YYYY")} ${dateToStr ? "To  " + moment(dateToStr).format("DD-MMM-YYYY") : ""}`],
      ["Depot:", depotStr?.name || "All Depot"],
      ["Client:", clientStr?.name || "All Client"],
      ["Project:", projectStr?.name || "All Project"]
    ]
    let ProjectManagerHeaderChanges = [
      ["Date:", `${moment(dateFromStr).format("DD-MMM-YYYY")} ${dateToStr ? "To  " + moment(dateToStr).format("DD-MMM-YYYY") : ""}`],
      ["Client:", clientStr?.name || "All Client"],
      ["Project:", projectStr?.name || "All Project"]
    ]

    let activeheader = userDetails?.roles == "ProjectManager" ? ProjectManagerHeaderChanges : AdminHeaderChanges

    const worksheet = XLSX.utils.aoa_to_sheet([
      ...activeheader,
      [],
      [],
      headers,
      ...tableData.map((d) => {
        const rowData = [
          d.referenceNumber,
          d.depot,
          d.manager,
          d.clientName,
          d.projectName,
          d.itemNumber,
          d.description,
          d.condition,
          d.quantityReceived,
          d.quantityDispatched,
          (d?.currentQuantity || 0)
        ];
        return rowData;
      }),
    ]);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

    // Generate the Excel file buffer
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Convert buffer to Blob and save the file
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const customFileName = `Inventory report ${moment().format(
      "DD:MMM:YYYY:HH:mm"
    )}.xlsx`;
    saveAs(data, customFileName);
  };

  const Print = () => {
    const depot = filterData?.depotId || "All Depot";
    const client = filterData?.clientId || "All Client";
    const project = filterData?.projectId || "All Project";
    saveExcelFile(
      monthlyData,
      filterData?.fromDate,
      filterData?.toDate,
      depot,
      client,
      project,
    );
  };

  if (loadingState) {
    return <Loader />;
  }
  return (
    <div
      style={{ paddingLeft: 16, background: "#ffffff" }}
      className={`${isDropdownOpenFlagValue == true || signoutModelOpenFlag == true
        ? "add-overlay-for-depot-dropdown"
        : ""
        }`}
    >
      <div
        className="table-responsive"
        // style={{ height: window.innerHeight - 150 }}
      >
        <table
          className="table goodsin-table table-borderless"
          style={{ width: "100%" }}
        >
          <thead className="goodsin-table-header">
            <tr>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 150,
                  }}
                >
                  REF NO
                </div>
              </th>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 150,
                  }}
                >
                  Depot
                </div>
              </th>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 150,
                  }}
                >
                  Manager
                </div>
              </th>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 150,
                  }}
                >
                  CLIENT
                </div>
              </th>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 300,
                  }}
                >
                  project
                </div>
              </th>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 150,
                  }}
                >
                  Items
                </div>
              </th>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 150,
                  }}
                >
                  description
                </div>
              </th>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 150,
                  }}
                >
                  condition
                </div>
              </th>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 150,
                  }}
                >
                  QTY received
                </div>
              </th>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 150,
                  }}
                >
                  QTY DISPATCHED
                </div>
              </th>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 150,
                  }}
                >
                  QTY REMAINING
                </div>
              </th>
            </tr>

          </thead>
          <tbody className="goods-table-body">
            {monthlyData.length > 0 &&
              monthlyData.map((d, index) => {
                return (
                  <tr
                    key={`monthlyReportSA${index}`}
                    className="reports-table-body-style-items-tr"
                  >
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          minHeight: "80px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {d.referenceNumber}
                      </div>
                    </th>
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          minHeight: "80px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {d.depot}
                      </div>
                    </th>
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          minHeight: "80px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {d.manager}
                      </div>
                    </th>
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          minHeight: "80px",
                          display: "flex",
                          alignItems: "center",
                          paddingLeft: 10,
                        }}
                      >
                        {
                          d?.clientName || ""
                        }
                      </div>
                    </th>
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          minHeight: "80px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {d?.projectName || ""}
                      </div>
                    </th>
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          minHeight: "80px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {
                          d?.itemNumber || ""
                        }
                      </div>
                    </th>
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          minHeight: "80px",
                          display: "flex",
                          alignItems: "center",
                          width: "150px",
                          wordBreak: "break-word"

                        }}
                      >
                        {d?.description || ""}
                      </div>
                    </th>
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          minHeight: "80px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {d?.condition || ""}
                      </div>
                    </th>
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          minHeight: "80px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {d?.quantityReceived || ""}
                      </div>
                    </th>
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          minHeight: "80px",
                          display: "flex",
                          alignItems: "center",
                          paddingLeft: 10,
                        }}
                      >
                        {d?.quantityDispatched || 0}
                      </div>
                    </th>
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          minHeight: "80px",
                          display: "flex",
                          alignItems: "center",
                          paddingLeft: 10,
                        }}
                      >
                        {(d?.currentQuantity || 0)}
                      </div>
                    </th>
                  </tr>
                );
              })}
          </tbody>
          <tfoot className="goodsin-table-footer-style">
            <tr>
              <td scope="col">
                <div style={{ fontFamily: "Montserrat-Regular", fontSize: 12 }}>
                  <div className="footer-count-color">{monthlyData?.length || 0}</div>
                  <div className="footer-label-color">Records</div>
                </div>
              </td>
              <td scope="col">
              </td>

              <td scope="col">
              </td>


              <td scope="col">
              </td>

              <td scope="col">

              </td>
              <td scope="col">

              </td>
              <td scope="col">
              </td>
              <td scope="col">
                <div
                  style={{ fontFamily: "Montserrat-Regular", fontSize: 12 }}
                ></div>
              </td>
              <td scope="col">
                <div style={{ fontFamily: "Montserrat-Regular", fontSize: 12 }}>
                  <div className="footer-count-color">
                    {_.sumBy(monthlyData, d => d.quantityReceived)}{" "}
                  </div>
                  <div className="footer-label-color">  Received.</div>
                </div>
              </td>
              <td scope="col">
                <div style={{ fontFamily: "Montserrat-Regular", fontSize: 12 }}>
                  <div className="footer-count-color">
                    {" "}
                    {_.sumBy(monthlyData, d => d.quantityDispatched)}{" "}
                  </div>
                  <div className="footer-label-color">Dispatch </div>
                </div>
              </td>
              <td scope="col">
                <div style={{ fontFamily: "Montserrat-Regular", fontSize: 12 }}>
                  <div className="footer-count-color">
                    {" "}
                    {_.sumBy(monthlyData, d => d?.currentQuantity || 0)}{" "}
                  </div>
                  <div className="footer-label-color">Total Remaining </div>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div className="d-flex justify-content-end me-3">
        <Button
          disabled={monthlyData?.length <= 0 ? true : false}
          variant="outlined"
          className={`mt-2 save-report-btn-style ms-2 ${monthlyData.length <= 0 ? "fade-out" : ""
            }`}
          startIcon={
            <img src={IconDownload} width={17} height={17} alt="new"></img>
          }
          type="submit"
          onClick={() => Print()}
        >
          Save Report
        </Button>
      </div>
    </div >
  );
};
